// 信用审批管理
const creditApprovalRouter = {
  path: 'credit-approval',
  name: 'credit-approval',
  component: { render: h => h('router-view') },
  children: [
    {
      path: 'apply',
      name: 'apply',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'credit-application-homepage',
          name: 'credit-application-homepage',
          component: () =>
            import(
              /* webpackChunkName: "credit-application-homepage" */ '@/views/credit-approval/apply/credit-application-homepage'
            ),
        },
        {
          path: 'credit-application-detail/:companyCode',
          name: 'credit-application-detail',
          component: () =>
            import(
              /* webpackChunkName: "credit-application-detail" */ '@/views/credit-approval/apply/credit-application-detail'
            ),
        },
        {
          path: 'credit-period-detail/:companyCode',
          name: 'credit-period-detail',
          component: () =>
            import('@/views/credit-approval/apply/credit-period-detail'),
        },
        {
          path: 'limit-extension-application-detail/:companyCode',
          name: 'limit-extension-application-detail',
          component: () =>
            import(
              '@/views/credit-approval/apply/extension/limit-extension-application-detail'
            ),
        },
        {
          path: 'special-extension-application-detail/:companyCode',
          name: 'special-extension-application-detail',
          component: () =>
            import(
              '@/views/credit-approval/apply/special/special-extension-application-detail'
            ),
        },
        {
          path: 'apply-list',
          name: 'apply-list',
          component: () =>
            import(
              /* webpackChunkName: "apply-list" */ '@/views/credit-approval/apply/apply-list'
            ),
        },
        {
          path: 'credit-batch-application',
          name: 'credit-batch-application',
          component: () =>
            import(
              /* webpackChunkName: "credit-batch-application" */ '@/views/credit-approval/apply/credit-batch-application'
            ),
        },
      ],
    },
    {
      path: 'approve',
      name: 'approve',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'approve-list',
          name: 'approve-list',
          component: () =>
            import(
              /* webpackChunkName: "approve-list" */ '@/views/credit-approval/approve/approve-list'
            ),
        },
        {
          path: 'approve-detail/:id',
          name: 'approve-detail',
          meta: {
            title: '账期调整审批',
          },
          component: () =>
            import(
              /* webpackChunkName: "approve-detail" */ '@/views/credit-approval/approve/approve-detail'
            ),
        },
        {
          path: 'approve-detail-view/:id',
          name: 'approve-detail-view',
          meta: {
            title: '账期调整审批详情',
          },
          component: () =>
            import(
              /* webpackChunkName: "approve-detail-view" */ '@/views/credit-approval/approve/approve-detail-view'
            ),
        },
      ],
    },
    {
      path: 'limit',
      name: 'limit',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'limit-list',
          name: 'limit-list',
          component: () => import('@/views/credit-approval/limit/limit-list'),
        },
        {
          path: 'special-list',
          name: 'special-list',
          component: () => import('@/views/credit-approval/limit/special-list'),
        },
        {
          path: 'batch-limit-list',
          name: 'batch-limit-list',
          component: () =>
            import('@/views/credit-approval/limit/batch-limit-list'),
        },
        {
          path: 'approval-detail/:id',
          name: 'approval-detail',
          meta: {
            title: '限额延期审批',
          },
          component: () =>
            import('@/views/credit-approval/limit/approval-detail'),
        },
        {
          path: 'special-approval-detail/:id',
          name: 'special-approval-detail',
          meta: {
            title: '专项额度延期审批',
          },
          component: () =>
            import('@/views/credit-approval/limit/special-approval-detail'),
        },
        {
          path: 'limit-batch-approval-detail/:bpmId',
          name: 'limit-batch-approval-detail',
          meta: {
            title: '批量审批详情',
          },
          component: () =>
            import('@/views/credit-approval/limit/limit-batch-approval-detail'),
        },
        {
          path: 'apply-detail/:id',
          name: 'apply-detail',
          meta: {
            title: '申请/审批详情',
          },
          component: () => import('@/views/credit-approval/limit/apply-detail'),
        },
      ],
    },
    {
      path: 'audit',
      name: 'audit',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'audit-list',
          name: 'audit-list',
          component: () =>
            import(
              /* webpackChunkName: "audit-list" */ '@/views/credit-approval/audit/audit-list'
            ),
        },
        {
          path: 'batch-audit-list',
          name: 'batch-audit-list',
          component: () =>
            import(
              /* webpackChunkName: "batch-audit-list" */ '@/views/credit-approval/audit/batch-audit-list'
            ),
        },
        {
          path: 'approval-detail/:id',
          name: 'approval-detail',
          meta: {
            title: '信用审批',
          },
          component: () =>
            import(
              /* webpackChunkName: "approval-detail" */ '@/views/credit-approval/audit/approval-detail'
            ),
        },
        {
          path: 'batch-approval-detail/:bpmId',
          name: 'batch-approval-detail',
          meta: {
            title: '批量审批详情',
          },
          component: () =>
            import(
              /* webpackChunkName: "batch-approval-detail" */ '@/views/credit-approval/audit/batch-approval-detail'
            ),
        },
        {
          path: 'limit-batch-approval-detail/:bpmId',
          name: 'limit-batch-approval-detail',
          meta: {
            title: '批量审批详情',
          },
          component: () =>
            import('@/views/credit-approval/audit/limit-batch-approval-detail'),
        },
      ],
    },

    {
      path: 'automatic',
      name: 'automatic',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'credit-application-homepage-auto',
          name: 'credit-application-homepage-auto',
          component: () =>
            import(
              /* webpackChunkName: "credit-application-homepage-auto" */ '@/views/credit-approval/automatic/credit-application-homepage-auto'
            ),
        },
        {
          path: 'credit-application-detail/:companyCode',
          name: 'credit-application-detail',
          component: () =>
            import(
              /* webpackChunkName: "credit-application-detail" */ '@/views/credit-approval/automatic/credit-application-detail'
            ),
        },
        {
          path: 'credit-period-detail/:companyCode',
          name: 'credit-period-detail',
          component: () =>
            import('@/views/credit-approval/automatic/credit-period-detail'),
        },
        {
          path: 'limit-extension-application-detail/:companyCode',
          name: 'limit-extension-application-detail',
          component: () =>
            import(
              '@/views/credit-approval/automatic/extension/limit-extension-application-detail'
            ),
        },
        {
          path: 'apply-list',
          name: 'apply-list',
          component: () =>
            import(
              /* webpackChunkName: "apply-list" */ '@/views/credit-approval/automatic/apply-list'
            ),
        },
        {
          path: 'credit-batch-application',
          name: 'credit-batch-application',
          component: () =>
            import(
              /* webpackChunkName: "credit-batch-application" */ '@/views/credit-approval/automatic/credit-batch-application'
            ),
        },
      ],
    },

    {
      path: 'record',
      name: 'record',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'record-list',
          name: 'record-list',
          component: () =>
            import(
              /* webpackChunkName: "record-list" */ '@/views/credit-approval/record/record-list'
            ),
        },
        {
          path: 'batch-record-list',
          name: 'batch-record-list',
          component: () =>
            import(
              /* webpackChunkName: "batch-record-list" */ '@/views/credit-approval/record/batch-record-list'
            ),
        },
        {
          path: 'automatic-record-list',
          name: 'automatic-record-list',
          component: () =>
            import(
              /* webpackChunkName: "automatic-record-list" */ '@/views/credit-approval/record/automatic-record-list'
            ),
        },
        {
          path: 'extension-record-list',
          name: 'extension-record-list',
          component: () =>
            import('@/views/credit-approval/record/extension-record-list'),
        },
        {
          path: 'batch-extension-record-list',
          name: 'batch-extension-record-list',
          component: () =>
            import(
              '@/views/credit-approval/record/batch-extension-record-list'
            ),
        },
        /* 账期调整审批记录  */
        {
          path: 'approve-list-record',
          name: 'approve-list-record',
          component: () =>
            import(
              /* webpackChunkName: "approve-list-record" */ '@/views/credit-approval/record/approve-list-record'
            ),
        },
      ],
    },
    {
      path: 'search',
      name: 'search',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'process-search',
          name: 'process-search',
          component: () =>
            import(
              /* webpackChunkName: "process-search" */ '@/views/credit-approval/search/process-search'
            ),
        },
        {
          path: 'process-search-auto',
          name: 'process-search-auto',
          component: () =>
            import(
              '@/views/credit-approval/search/process-search-auto'
            ),
        },
        {
          path: 'crm-search',
          name: 'crm-search',
          component: () =>
            import(
              /* webpackChunkName: "crm-search" */ '@/views/credit-approval/search/crm-search'
            ),
        },
        {
          path: 'batch-search',
          name: 'batch-search',
          component: () =>
            import(
              /* webpackChunkName: "batch-search" */ '@/views/credit-approval/search/batch-search'
            ),
        },
      ],
    },
    {
      path: 'apply-detail/:id',
      name: 'apply-detail',
      meta: {
        title: '申请/审批详情',
      },
      component: () =>
        import(
          /* webpackChunkName: "apply-detail-page" */ '@/views/credit-approval/apply-detail'
        ),
    },
    {
      path: 'apply-rule',
      name: 'apply-rule',
      component: () =>
        import(
          /* webpackChunkName: 'apply-list' */ '@/views/credit-approval/rule/apply-rule'
        ),
    },
    {
      path: 'period-rule',
      name: 'period-rule',
      component: () =>
        import(
          /* webpackChunkName: 'period-list' */ '@/views/credit-approval/rule/period-rule'
        ),
    },
    {
      path: 'credit-period',
      name: 'credit-period',
      component: () =>
        import(
          /* webpackChunkName: 'credit-period' */ '@/views/credit-approval/apply/credit-period'
        ),
    },
    {
      path: 'period-batch-application',
      name: 'period-batch-application',
      component: () =>
        import(
          '@/views/credit-approval/apply/extension/period-batch-application'
        ),
    },
    {
      path: 'apply',
      name: 'apply',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'limit-extension-application',
          name: 'limit-extension-application',
          component: () =>
            import(
              '@/views/credit-approval/apply/extension/limit-extension-application'
            ),
        },
        {
          path: 'limit-batch-application',
          name: 'limit-batch-application',
          component: () =>
            import(
              '@/views/credit-approval/apply/extension/limit-batch-application'
            ),
        },
        {
          path: 'special-extension-application',
          name: 'special-extension-application',
          component: () =>
            import(
              '@/views/credit-approval/apply/special/special-extension-application'
            ),
        },
        {
          path: 'extension-list',
          name: 'extension-list',
          component: () =>
            import('@/views/credit-approval/apply/extension/extension-list'),
        },
      ]
    }
  ],
}

export default creditApprovalRouter
